import { Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import BuildAgents from './pages/BuildAgents';
import CourseAIEngineering from './pages/CourseAIEngineering';
import CourseDataEng from './pages/CourseDataEng';
import CourseVibeCoding from './pages/CourseVibeCoding';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <Navigation />
      <main className="pt-16">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/build-agents" element={<BuildAgents />} />
          <Route path="/courses/ai-engineering" element={<CourseAIEngineering />} />
          <Route path="/courses/data-engineering" element={<CourseDataEng />} />
          <Route path="/courses/vibe-coding" element={<CourseVibeCoding />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;